// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Wj0M","top":"styles_top__2cnKt","left":"styles_left__3sePK","description":"styles_description__2MgLv"};